const messages = {
    bonus: {
        title: "Overview Bonus credits",
        description:
            "Bonus in Euro are awarded to participating companies based on submitted sales figures.",
        lastMonth: "Last month",
        currentMonth: "Current month",
        totalCurrentYear: "Total current year",
        totalLastYear: "Total last year",
    },
    points: {
        title: "Overview Points credits",
        period: "Current calendar year ({year})",
        totalAwarded: "Total points awarded",
        redeemed: "Points redeemed",
        totalBalance: "Total points balance",
        redemptionRate: "Redeemed points as a percentage of points awarded",
        averageAwarded: "Average points awarded per tire purchased",
        standardAwarded: "Net points from calculated sales lines, including returns",
        bsPlusInclBooster: "Points from sales lines with a positive quantity",
        perTire: "Points redeemed per tire purchased",
    },
    tires: {
        title: "Overview amount of tires",
        description: "Tires purchased by the customers",
        prevMonth: "Previous month",
        totalLastYear: "Total last year",
        purchaseIndirect: "Purchase through Wholesale (indirect)",
        purchaseDirect: "Purchase through Wholesale (direct)",
        totalCurrentYear: "Total current year",
        currentMonth: "Current month",
    },
    participating: {
        title: "Overview of participating customers",
        description:
            "Companies that register with BRIDGESTONE PLUS can be assigned by us via the customer number.",
        total: "Total",
        newThisMonth: "New this month",
        newThisYear: "New this year",
        createdInCurrentMonth: "Created in current month (by admin)",
        loginsCurrentYear: "Logins current year (after accepting T&C's)"
    },
    brand: {
        title: "Brand",
        description: "Your purchases on detail",
        centerTitle: "By\nBrand"
    },
    rim: {
        title: "Rim",
        centerTitle: "Per rim\nSize"
    },
    tireGoals: {
        title: "Tire achievement goals",
        subtitle: "Earn points for your tire purchases.",
        centerTitle: "By\nTire size",
        tiresRemaining: "Tires remaining",
        progressionTarget: "Progression target: ",
        pointsEarnedPurchases: "points earned\n" + "by your \n" + "purchases",
        pointsEarnedBoosters: "points earned \n" + "by \n" + "boosters ",
        purchasesDetail: "Your purchases in detail",
        cta: "Find out more about your points",
        pointsTitle: "Your points",
        pointsSubtitle: "Points earned on your Bridgestone purchases",
        achievementsTitle: "Your achievements ",
        achievementsSubtitle: "Your annual commitment:",
        achievementsSubtitle2: "tires"
    },
    score: {
        title: 'Score',
        total: 'Total',
        credits: 'Credits in',
        deductions: 'Deductions in',
        unlockedPoints: 'Unlocked points',
        pendingPoints: 'Pending points',
    },
    boosterCcs: {
        title: "Booster CCS campaign",
        historyTitle: "Booster CCS campaign",
        historyDescription: "All your Booster CCS results by period.",
        seeMore: "See more",
        empty: "No Booster CCS results available.",
        exploreResults: "Explore your results",
        learnMechanics: "Learn more about the mechanics",
        yourRealisation: "Your achievements",
        yourPoints: "Your points",
        soldTyres: "Tyres sold",
        receivedPoints: "Points earned",
        pointsBySales: "Points earned from your Bridgestone tyre sales",
        salesDetail: "Your sales in detail",
        tyreLimitInfo:
            "A minimum sell-out volume of 50 Bridgestone and/or Firestone tyres is required for each Booster campaign period",
        noSalesBreakdown: "No sales breakdown available for this period yet.",
        charts: {
            byBrand: "By brand",
            bySize: "By rim<br/>size",
        },
    },
    score_extended: {
        title1: "Points balance",
        title2: "Bonus in Euro",
        balance: "Points balance",
        bonus_in_euro: "Bonus in Euro",
        date: "Date",
        added_points: "Points added in",
        total_bands: "Total bands",
        goal: "Goal",
        tyres_previous_year: "Tyres Sold Last Year",
        tyres_current_year: "Tyres Sold This Year",
        target_this_year: "Sales Target This Year",
        bonus_this_year: "Bonus Earned (€)",
        loyal_minimum: "Loyalty Minimum Level",
        bonus_multiplier: "Bonus Multiplier Rate"
    },
    lastImport: {
        label:"Last import on sales figures:",
        on: "on"
    },
    wholesalerTable: {
        title: "Participating customers in detail",
        description:
            "Below you will find the companies that have registered on BRIDGESTONE PLUS with your company's customer number. " +
            "You can use the filters for a different sorting or the search function to look up customers.",
        columns: {
            customer_number: "Cust No.",
            address_company_name: "Company",
            address_street: "Street & house number",
            address_postal_code: "Postal Code",
            address_city: "City",
            last_registration: "Last Registration",
            network: "Network",
            profile_group: "Group",
            tires_amount: "Tires Amount",
            point_balance: "Point Balance",
            bonus: "Bonus",
            details: "Details"
        },
        searchPlaceholder: "Search"
    },
    dealerTable: {
        columns: {
            date: "Date",
            wholesaler_bs_plus: "Wholesaler BS+",
            customer_number: "Customer Number",
            article: "Article",
            brand: "Brand",
            product: "Product",
            type: "Type",
            inch: "Inch",
            season: "Season",
            amount: "Amount",
            points: "Points",
            activity: "Activity",
            total_points: "Total Points"
        },
        title: "Dealer Table",
        description: "Overview of dealer activities",
    },
    business_units: {
        title: "Business units",
        centerTitle: "Per\n unit",
    },
    season: {
        title: "Season",
        centerTitle: "Per Time \n of the year",
    },
}

export default {
    messages,
};